<template>
    <div class="l-stacked-grid l-stacked-grid--left">
        <div class="l-stacked-grid__item">
            <div class="c-form__search">
                <span class="icon-search"></span>
                <input autocomplete="off" v-model="search" type="text" name="search" :placeholder="$t(i18n.search.placeholder)"
                       @keyup="updateSearch">
                <ul v-if="showAutoCompleteDropdown && filteredEmployeeList.length">
                    <li v-for="(employee, i) in filteredEmployeeList.slice(0, autocompleteListLengthLimit)"
                        :key="i"
                        :class="{ 'is-active': i === selectedResultIndex }"
                        @click="onEnterSelected(employee)">
                            {{employee.emailAddress}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="l-stacked-grid__item">
            <div class="c-sortable-list__search-result-amount">
                <span v-if="search">{{filteredEmployeeList.length}} {{resultsText}} "{{search}}"</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {goToSpecialPage} from "@bvm/core/src/api/specialpage/specialpage.api";
    import {Utils} from "@bvm/core";

    const i18nBuilder = new Utils.I18n.I18nBuilder('employee_overview')
        .add('search', b => b.add('placeholder'))
    export const messageKeys = i18nBuilder.getKeys();

    export default {
        name: "SortableListSearch",
        props: {
            employeeList: {type: Array, required: true},
            resultsText: {type: String, required: true}
        },
        data() {
            return {
                i18n: i18nBuilder.getData(),
                search: "",
                showAutoCompleteDropdown: false,
                selectedResultIndex: -1,
                autocompleteListLengthLimit: 5
            }
        },
        computed: {
            filteredEmployeeList() {
                return this.employeeList.filter(employee => employee.emailAddress.toLowerCase().includes(this.search.toLowerCase()));
            }
        },
        methods: {
            click(employee) {
                this.onEnterSelected(employee);
            },
            updateSearch(event) {
                switch (event.key) {
                    case "Enter":
                        this.onEnter(event);
                        break;
                    case "ArrowUp":
                        this.onArrowUp();
                        break;
                    case "ArrowDown":
                        this.onArrowDown();
                        break;
                    default:
                        this.onTextInput();
                }
            },
            onEnter(event) {
                if (this.selectedResultIndex < 0) {
                    this.showAutoCompleteDropdown = false;
                    this.selectedResultIndex = -1;
                    this.$emit('input', event.target.value)
                } else {
                    this.onEnterSelected(this.filteredEmployeeList[this.selectedResultIndex])
                }
            },
            onEnterSelected(employee) {
                goToSpecialPage('ADMIN_EDIT', {key: 'id', value: employee.id});
            },
            onArrowDown() {
                if (this.showAutoCompleteDropdown && this.selectedResultIndex < Math.min(this.filteredEmployeeList.length, this.autocompleteListLengthLimit - 1)) {
                    this.selectedResultIndex = this.selectedResultIndex + 1;
                }
                this.showAutoCompleteDropdown = true;
            },
            onArrowUp() {
                if (this.showAutoCompleteDropdown && this.selectedResultIndex > -1) {
                    this.selectedResultIndex = this.selectedResultIndex - 1;
                }
            },
            onTextInput() {
                if (this.search) {
                    this.showAutoCompleteDropdown = true;
                } else {
                    this.showAutoCompleteDropdown = false;
                    this.$emit('input', "")
                }
            }
        }
    }
</script>
